import React, {useEffect, useState} from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import {Link} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {useHistory} from 'react-router';
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";

import {API_URL} from '../constants.js';

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {useTranslation} from "react-i18next";

export function BlueRemarksList(props) {
    const { t } = useTranslation();
    const [blueRemarks, setBlueRemarks] = useState([]);
    const [blueRemark, setBlueRemark] = useState(null);
    const [show, setShow] = useState(false);
    const history = useHistory();
    const [disabled, setDisabled] = useState(0);

    const setCurrentBlueRemark = (item) => {
        setBlueRemark(item);
        setShow(true);
    };

    const handleClose = () => setShow(false);

    const deleteBlueRemark = () => {
        setDisabled(1);
        axios.post(
            API_URL + 'blue-remarks/' + blueRemark.id + '/delete'
        ).then((response) => {
            if (response.data.status) {
                history.go(0);
                setShow(false);
                alertify.success(response.data.message);
            } else {
                setDisabled(0);
                alertify.error(response.data.message);
            }
        }).catch(() => {
            setDisabled(0);
            alertify.error("Something went wrong. Try again!");
        });
    };

    useEffect(() => {
        axios.get(API_URL + 'blue-remarks').then((response) => {
            if (response.data.status) {
                setBlueRemarks(response.data.data);
                $("#blue_remarks_table").DataTable();
            } else {
                alertify.error(response.data.message);
            }
        }).catch(() => {
            alertify.error("Something went wrong. Try again!");
        });
    }, []);

    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title={t("Blue Remarks List")}>
                            <CardHeaderToolbar>
                                <Link to="/blue-remarks/create" className="btn btn-primary btn-sm mx-3">
                                    {t("Create Blue Remark")}
                                </Link>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody style={{overflow:'auto'}}>
                            <table id="blue_remarks_table" className="stratprop_datatable table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>{t("SN.")}</th>
                                    <th>{t("Name")}</th>
                                    <th>{t("Description")}</th>
                                    <th>{t("Actions")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {blueRemarks.length > 0 ? (
                                    blueRemarks.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.name}</td>
                                            <td>{item.description}</td>
                                            <td>
                                                <Link to={`/blue-remarks/edit/${item.id}`}
                                                      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
                                                    <span className="svg-icon svg-icon-md svg-icon-primary">
                                                        <SVG
                                                            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                                                        />
                                                    </span>
                                                </Link>
                                                <a
                                                    onClick={() => setCurrentBlueRemark(item)}
                                                    className="btn btn-icon btn-light btn-hover-danger btn-sm">
                                                    <span className="svg-icon svg-icon-md svg-icon-danger">
                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>
                                                    </span>
                                                </a>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4}>{t("No Blue Remarks")}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("Delete Blue Remark")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("Are you sure you want to Delete?")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("Close")}
                    </Button>
                    <Button variant="primary" onClick={deleteBlueRemark} disabled={disabled}>
                        {t("Confirm")}
                        <span
                            dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
